type SanityImageObject = {
	id: string;
	type: string;
	widthHeight: string;
	format: string;
	width: number;
	height: number;
}

/**
 * image-G3i4emG6B8JnTmGoN0UjgAp8-300x450-jpg
 * @see {link: https://www.sanity.io/docs/image-url} for more information
 * @param ref - Should be in the format of image-G3i4emG6B8JnTmGoN0UjgAp8-300x450-jpg
 */
export const sanityImageObjectFromRef = (ref: string): SanityImageObject => {
	const [type, id, widthHeight, format] = ref.split('-');
	const [width, height] = widthHeight.split('x').map(item => parseInt(item));

	if (!type || !id || !widthHeight || !format || isNaN(width) || isNaN(height)) {
		throw new Error(`Invalid Sanity image reference: ${ref}`);
	}

	return {
		type,
		id,
		widthHeight,
		format,
		width,
		height
	};
};

/**
 * Creates a Sanity CDN image URL from the given projectId, dataset and image object.
 * @see {link: https://www.sanity.io/docs/image-url} for more information
 * @param projectId - Sanity project ID
 * @param dataset - Sanity dataset name - usually 'production'
 * @param img
 */
export const createSanityCdnImageUrl = (projectId: string, dataset: string, img: SanityImageObject) => {
	if (!projectId || !dataset || !img) {
		return '';
	}

	const {id, widthHeight, format} = img;

	if (!id || !widthHeight || !format) {
		return '';
	}

	return `https://cdn.sanity.io/images/${projectId}/${dataset}/${id}-${widthHeight}.${format}`;
};

